import { Component } from '@angular/core';

@Component({
  selector: 'pg-dashboard-component',
  templateUrl: './dashboard.component.html'
})
export class AmigaDashboardComponent {}
